import { OfferSource } from '@cds';
import { Participant, ParticipantType } from '@cds/betting-offer';
import { EventOption, EventParticipantImage } from '@frontend/sports/betting-offer/feature/model';

export const getOptionImage = (
    participants: Participant[],
    option: EventOption,
    participantImageMap: Map<number | undefined, EventParticipantImage>,
): EventParticipantImage => {
    const participant: Participant | undefined = participants?.find((participant) => {
        if (participant.properties?.type !== ParticipantType.Player) return false;

        if (participant.source === OfferSource.V2) {
            return (
                [option.participantId, option.optionPlayerId].includes(participant.id) ||
                (participant.name?.value === option.name && [option.player1Id, option.player2Id].includes(participant.participantId))
            );
        }

        return (
            [option.playerId, option.player1Id].includes(participant.participantId) ||
            [participant.name?.value, participant.name?.short].includes(option.player1)
        );
    });

    if (participant) {
        const teamImage = participantImageMap.get(participant.properties?.team);
        return {
            ...participant.image,
            logoColor: teamImage?.logoColor,
            ...(participant.source === OfferSource.V2 && { headshot: teamImage?.headshot }),
        } satisfies EventParticipantImage;
    }

    return {};
};
export const getParticipantImageMap = (participants: Participant[]): Map<number, EventParticipantImage> => {
    const participantImageMap = new Map();
    participants?.forEach((participant) => {
        if (
            participant.properties?.type !== ParticipantType.Player &&
            (participant.source === OfferSource.V1 || participant.source === OfferSource.V2)
        ) {
            participantImageMap.set(participant.participantId, participant.image);
        }
    });
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return participantImageMap;
};
